module.exports = {"420104001":"古田街道","420104002":"韩家墩街道","420104003":"宗关街道","420104004":"汉水桥街道","420104005":"宝丰街道","420104006":"荣华街道","420104008":"汉中街道","420104009":"汉正街道","420104010":"六角亭街道","420104011":"长丰街道","420104012":"易家街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420104.json
// module id = 1700
// module chunks = 0